/* eslint-disable unicorn/no-this-assignment */
/* eslint-disable no-console */
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';
import Select from '../../components/Select';

const CLICK_EVENT = 'click';

class AllResources {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.lta-all-resources');
		if (!this._wrapper) {
			return;
		}
		this.initEvents();
		this.state = {
			serachInput: '',
			selectedCategories: []
		};
	}

	initEvents() {
		// Events on Tabs Changes and Searches
		const current = this;
		const serachInputText = SelectorEngine.findOne('#search-all-resources', this._wrapper);
		const searchButton = SelectorEngine.findOne('.all-search-btn', this._wrapper);
		const category = SelectorEngine.findOne('.lta-all-resources-category-select', this._wrapper);

		if (serachInputText) {
			EventHandler.on(serachInputText, 'change', (event) => {
				this.saveSerachInput(event);
			});
		}

		if (category) {
			this.categoryElement = SelectorEngine.findOne('.js-lta-select', category);
			this.categorySelect = Select.getInstance(this.categoryElement) || new Select(this.categoryElement);
			EventHandler.on(this.categorySelect._selectNativeElement, 'change', (event) => {
				this.saveCategory(event);
			});
		}

		const applyFilter = SelectorEngine.findOne('.lta-all-resources-filter__btn', this._wrapper);
		const formElement = SelectorEngine.findOne('.js-all-resources-search-form', this._wrapper);
		EventHandler.on(searchButton, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		EventHandler.on(applyFilter, CLICK_EVENT, () => {
			this.generateQueryString(formElement);
		});

		const allBookmarkContainers = SelectorEngine.find('.lta-bookmark-container', this._wrapper);
		for (const container of allBookmarkContainers) {
			const addBookmarkButton = SelectorEngine.findOne('.lta-add-bookmark', container);
			const removeBookmarkButton = SelectorEngine.findOne('.lta-remove-bookmark', container);

			EventHandler.on(addBookmarkButton, CLICK_EVENT, (event) => {
				const pageId = Manipulator.getDataAttribute(addBookmarkButton, 'page-id');
				this.addBookmark(event, pageId, removeBookmarkButton);
			});

			EventHandler.on(removeBookmarkButton, CLICK_EVENT, (event) => {
				const pageId = Manipulator.getDataAttribute(removeBookmarkButton, 'page-id');
				this.removeBookmark(event, pageId, addBookmarkButton);
			});
		}
	}

	saveSerachInput(event) {
		const targetValue = event.target.value;
		this.state.serachInput = targetValue;
	}

	saveCategory(event) {
		const selectedValues = [];
		// Loop through each option and add selected values to the array
		for (let index = 0; index < event.target.options.length; index++) {
			if (event.target.options[index].selected) {
				selectedValues.push(event.target.options[index].value);
			}
		}
		this.state.selectedCategories = selectedValues;
	}

	generateQueryString(formElement) {
		formElement.submit();
	}

	encodeParam(value) {
		return encodeURIComponent(value.replace(/&/g, '&amp;'));
	}

	async addBookmark(event, pageId, element) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/bookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async removeBookmark(event, pageId, element) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/unbookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
}

const globalAllResources = new AllResources();
export default globalAllResources;
